export default "__VITE_ASSET__p8eXw5IP__"